
<ng-container *ngIf="GED?.ElementsList?.length > 0 && GED?.ElementsList[0].InnerElementsList">
  <ng-container *ngFor="let folder of GED.ElementsList[0].InnerElementsList">
    <li class="accordion q-bold q-text-m" (click)="folder.IsVisible = true; GedFolderClicked($event.currentTarget, folder)">
      {{folder.Text}}
    </li>

    <ul class="panel">
      <!--style="width:0px">-->
      <ng-container *ngIf="folder.IsVisible" [ngTemplateOutlet]="AfficheGED" [ngTemplateOutletContext]="{folder:folder}"></ng-container>
    </ul>
  </ng-container>
</ng-container>

<ng-template #AfficheGED let-folder="folder">
  <ng-container *ngFor="let file of folder.Files">
    <li [ngClass]="{'radio': singleMode}" class="q-pointer q-check p-0 ml-2 my-1 q-text-m">
      <input *ngIf="!singleMode" type="checkbox" [(ngModel)]="file.selected" class="d-none" />
      <input *ngIf="singleMode" type="radio" name="GED" [value]="file.value" [checked]="file.selected" class="d-none" />
      <label class="align-items-center" style="white-space:nowrap;" (click)="ToggleFile($event, file)">
        <span style="height: 15px; width: 15px;"></span><i class="far fa-file-alt mx-1"></i> {{file.key}}
      </label>
    </li>
  </ng-container>
  <ng-container *ngFor="let child of folder.Children">
    <li class="accordion q-bold q-text-m" (click)="child.IsVisible = true;GedFolderClicked($event.currentTarget, child)"> {{child.Text}}</li>
    <ul class="panel">
      <!--style="width:0px">-->
      <ng-container *ngIf="child.IsVisible" [ngTemplateOutlet]="AfficheGED" [ngTemplateOutletContext]="{folder:child}"></ng-container>
    </ul>
  </ng-container>
</ng-template>
